import { SmartDmMeasurementParser } from './SmartDmMeasurementParser';
import type { ParsedData } from '../../../../interfaces/toolData';

/**
 * Parser for JAE Smart DM SHKVIBE files
 * 
 * Handles shock and vibration measurements:
 * - CLOCK_TICKS (system clock ticks)
 * - XH_MAX, ZH_MAX (maximum shock values)
 * - XH_ACCEL, ZH_ACCEL (acceleration values)
 * - FLOW (flow state)
 */
export class SmartDmShkVibeParser {
  static parse(fileContent: string): ParsedData {
    const unitMappings = {
      'CLOCK_TICKS': 'ticks',
      'XH_MAX': 'G',
      'ZH_MAX': 'G', 
      'XH_ACCEL': 'G',
      'ZH_ACCEL': 'G',
      'FLOW': 'state'
    };
    
    return SmartDmMeasurementParser.parse(
      fileContent,
      'SHKVIBE',
      'JAE_SMARTDM_SHKVIBE',
      unitMappings
    );
  }
} 